<template>
	<div id="boxSelezionaFarmacoPrescrizione" class="sa-bancafarmaci sa-bancafarmaci-hidden">
		<b-tabs v-model="prescrizioneActiveTabIndex" content-class="mt-3 sa-tab-content" fill class="sa-tab"
			style="height: 100%; padding-bottom: 25px; position: relative; z-index: 0" @input="onInputTabs">
			<b-tab title="Armadietto" id="tbFarmaci" class="sa-test">
				<template #title> <i class="fas fa-flask"></i><span style="padding-left: 10px">Armadietto</span>
				</template>
				<div style="height: 100%; width: 100%; padding-bottom: 10px">
					<contabilita-articoli-magazzino-dettagli-list-component
						@confermaSelezione="onConfermaSelezioneFarmaco" @annullaSelezione="onAnnullaSelezioneFarmaco"
						ref="cmpContabilitaArticoliMagazzinoDettagliList"></contabilita-articoli-magazzino-dettagli-list-component>
				</div>
			</b-tab>
			<b-tab title="Magazzino Centrale" id="tbFarmaci" class="sa-test">
				<template #title><i class="fas fa-warehouse"></i><span style="padding-left: 10px">Magazzino</span>
				</template>
				<div style="height: 100%; width: 100%; padding-bottom: 10px">
					<contabilita-articoli-magazzino-dettagli-list-component
						@confermaSelezione="onConfermaSelezioneFarmaco" @annullaSelezione="onAnnullaSelezioneFarmaco"
						ref="cmpContabilitaArticoliMagazzinoCentraleDettagliList"></contabilita-articoli-magazzino-dettagli-list-component>
				</div>
			</b-tab>
			<b-tab title="Banca Farmaci" id="tbFarmaci" class="sa-test">
				<template #title> <i class="fas fa-capsules"></i><span style="padding-left: 10px">Banca Farmaci</span>
				</template>
				<div style="height: 100%; width: 100%; padding-bottom: 10px">
					<rsa-paziente-prescrizione-banca-farmaci-component
						@confermaSelezione="onConfermaSelezioneFarmacoBancaFarmaci"
						@annullaSelezione="onAnnullaSelezioneFarmaco"
						ref="cmpRsaPazientePrescrizioneBancaFarmaciComponent"></rsa-paziente-prescrizione-banca-farmaci-component>
				</div>
			</b-tab>
		</b-tabs>
	</div>
</template>
<script>
import toast from "../../../../template/layout/utility/sa-toast";
import ContabilitaArticoliMagazzinoDettagliListComponent from "../../../contabilita/components/ContabilitaArticoliMagazzinoDettagliListComponent.vue";
import UtilityMixin from "../../../utility/UtilityMixin";
import RsaPazientePrescrizioneBancaFarmaciComponent from "./RsaPazientePrescrizioneBancaFarmaciComponent.vue";

export default {
	components: { RsaPazientePrescrizioneBancaFarmaciComponent, ContabilitaArticoliMagazzinoDettagliListComponent },
	data() {
		return {
			prescrizioneActiveTabIndex: 0,
			numeroAccettazione: null,
			jsonDataAccettazione: null,
			pathResourceFarmaci: "/farmaci",
		};
	},
	methods: {
		init(jsonDataAccettazione) {
			let me = this;
			me.jsonDataAccettazione = jsonDataAccettazione;
			me.numeroAccettazione = jsonDataAccettazione.numero;
			me.inputTabs(me.prescrizioneActiveTabIndex);
		},
		onInputTabs(value) {
			let me = this;
			me.inputTabs(value);
		},
		inputTabs(value) {
			let me = this;
			let filtro = {};
			switch (value) {
				case 0:
					filtro = { codiceStruttura: me.jsonDataAccettazione.accettazioneStruttura.codiceStruttura, magazzinoCodice: me.numeroAccettazione };
					me.$refs.cmpContabilitaArticoliMagazzinoDettagliList.init(filtro, true);
					break;
				case 1:
					me.$refs.cmpContabilitaArticoliMagazzinoCentraleDettagliList.init(null, false);
					break;
			}
		},
		onAnnullaSelezioneFarmaco() {
			this.$emit("annullaSelezione");
		},
		onConfermaSelezioneFarmacoBancaFarmaci(item) {
			let me = this;
			if (item.codiceProdotto) {
				let codiceAic = item.codiceProdotto;
				UtilityMixin.methods.loadDataResources(me.pathResourceFarmaci + "/" + codiceAic, {}, me.resultResponseLoadFarmaci, me.resultErrorLoadFarmaci);
			} else {
				toast.error("Attenzione l'articolo non è configurato come farmaco o manca l'AIC", "Attenzione");
			}
		},
		onConfermaSelezioneFarmaco(item) {
			let me = this;
			if (item.atcGmp) {
				let codiceAic = item.atcGmp ? item.atcGmp : item.codiceAic;
				UtilityMixin.methods.loadDataResources(me.pathResourceFarmaci + "/" + codiceAic, {}, me.resultResponseLoadFarmaci, me.resultErrorLoadFarmaci);
			} else {
				toast.error("Attenzione l'articolo non è configurato come farmaco o manca l'AIC", "Attenzione");
			}
		},
		resultResponseLoadFarmaci(response) {
			let item = response.data.data;
			this.$emit("confermaSelezione", item);
		},
		resultErrorLoadFarmaci(error) {
			console.log(error.response.data.messaggio);
		},
	},
};
</script>

<style lang="scss" scoped></style>
